import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerified = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
		fill: "#248E61"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.042 6.04898C16.374 6.38098 16.374 6.92014 16.042 7.25213L9.24275 14.0514C8.91076 14.3834 8.3716 14.3834 8.03961 14.0514L4.63999 10.6518C4.30799 10.3198 4.30799 9.7806 4.63999 9.4486C4.97198 9.11661 5.51114 9.11661 5.84313 9.4486L8.64251 12.2453L14.8415 6.04898C15.1735 5.71699 15.7127 5.71699 16.0447 6.04898H16.042Z",
		fill: "white"
	})]
});
export default SvgVerified;
